// extracted by mini-css-extract-plugin
export var growableInput = "_6p-0";
export var tagContainer = "_6p-2";
export var textInput = "_6p-1";